import { Loader } from '@progress/kendo-react-indicators';
import React, { useState, useEffect, useCallback } from 'react';

export default function CurrencyConvert({ props }) {
  const [currency, setCurrency] = useState([]);
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState(
    'https://cdn.jsdelivr.net/gh/fawazahmed0/currency-api@1/latest/currencies/eur.json'
  );

  const fetchCurrency = useCallback(async () => {
    const response = await fetch(url);
    const json = await response.json();
    setCurrency(json);
    setLoading(false);
  }, [url]);

  useEffect(() => {
    fetchCurrency();
  }, [fetchCurrency]);
  return (
    <div
      className={`card card-custom bg-radial-gradient-info ${props?.className}`}
    >
      {/* begin::Header */}
      <div className="card-header border-0 pt-5">
        <h3 className="card-title font-weight-bolder text-white">
          Curreny Today
        </h3>
        <div className="card-toolbar"></div>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className="card-body d-flex flex-column p-0">
        {loading ? (
          <div className="row" style={{ minHeight: '200px' }}>
            <Loader
              size="large"
              style={{ position: 'relative', margin: '60px auto' }}
              type="converging-spinner"
            />
          </div>
        ) : (
          <>
            <div className="card-spacer bg-white card-rounded flex-grow-1">
              <div className="row m-0">
                <div className="col px-8 py-6 mr-8">
                  <div className={`font-size-sm text-muted font-weight-bold`}>
                    EURO
                  </div>
                  <div className="font-size-h4 font-weight-bolder">
                    {currency.eur['egp']}
                  </div>
                </div>
                <div className="col px-8 py-6 mr-8">
                  <div className={`font-size-sm text-muted font-weight-bold`}>
                    USD
                  </div>
                  <div className="font-size-h4 font-weight-bolder">
                    {currency.eur['egp'] / currency.eur['usd']}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
